export const buildPrivateAddressPayload = (privateAddress) => ({
  id: privateAddress.id,
  alias: privateAddress.alias,
  area_code: privateAddress.area_code,
  address_type: 'private',
  address_line_1: privateAddress.address_line_1,
  address_number: privateAddress.address_number,
  city: privateAddress.city,
  postal_code: privateAddress.postal_code,
  address_line_2: privateAddress.address_line_2 || undefined,
});

export const buildCompanyAddressPayload = (companyAddress) => ({
  id: companyAddress.id,
  company_name: companyAddress.company_name,
  area_code: companyAddress.area_code,
  address_type: 'company',
  address_line_1: companyAddress.address_line_1,
  address_number: companyAddress.address_number,
  city: companyAddress.city,
  postal_code: companyAddress.postal_code,
  address_line_2: companyAddress.address_line_2 || undefined,
});

export const buildAddressPayload = ({
  privateAddress,
  companyAddress,
  preferredAddress,
}) => {
  const address = [];

  if (privateAddress?.alias) {
    address.push(buildPrivateAddressPayload(privateAddress));
  }

  if (companyAddress?.company_name) {
    address.push(buildCompanyAddressPayload(companyAddress));
  }

  if (address.length === 0) {
    return {address: undefined, preferredAddress: undefined};
  }

  if (address.length === 1) {
    return {
      address,
      preferredAddress: address[0].address_type,
    };
  }

  return {
    address,
    preferredAddress: preferredAddress || undefined,
    requiresPreferredAddress: !preferredAddress,
  };
};

export const hasAnyAddressFieldFilled = (address = {}) =>
  Object.values(address).some((value) => value !== undefined && value !== '');
